import React, {useState, useEffect, useCallback} from 'react'
import styles from './Certificates.module.scss'
import { motion } from "framer-motion"
import { v4 as uuidv4 } from 'uuid'
import ScreenSize from '../../hooks/ScreenSize'
import CardImage  from '../CardImage/CardImage'
import { arrPortfolio } from '../../utils/data'
import { arrPortfolioModal } from '../../utils/data'
import wp from '../../image/InitialPage/touch.svg'

const titleAnimation = {
    hidden: {
        y: 100,
        opacity: 0,
    },

    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .3 }
    }
}

const cardAnimation = {
    hidden: {
        y: 100,
        opacity: 0,
    },
    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .4}
    } 
}


const Certificates = ({isImageOpen, isRus}) => {

     const width = ScreenSize()
    const [moviesTotal, setMoviesTotal] = useState(0)


    useEffect(() => {
        const getCards = () => {
            if (width >= 980) {
                setMoviesTotal(6);
                } else if (width < 980 && width >= 500) {
                    setMoviesTotal(6);
                        } else if (width <= 500) {
                            setMoviesTotal(6);
                            }
        }
        getCards();
    }, [width])

    const cardClick = useCallback(() => {
            isImageOpen(arrPortfolioModal)
        }, [isImageOpen])

    return (
        <motion.section 
        className={styles.main}
        id='gruppy' 
        initial='hidden'
        whileInView='visible'
        viewport={{amount: 0.05, once: true}}
        >
        <div className={styles.container}>
        <motion.h2 className={styles.title} variants={titleAnimation}>{isRus ? 'НАГРАДЫ И ДИПЛОМЫ' : 'AWARDS AND DIPLOMAS'}</motion.h2>
        <motion.ul className={styles.list}>
            {arrPortfolio.map((item, index) =>{
                        const keyUid = uuidv4()
                        if (index + 1 <= moviesTotal) {
                            return(
                                <CardImage
                                    key={keyUid}
                                    item={item}
                                    index={index}
                                />
                            ) 
                        }else {
                            return ''
                        }
                    })}
        </motion.ul>
        <div className={styles.box_button}>
                        <button className={styles.button} type='button' onClick={cardClick}>{isRus ? 'смотреть подробнее' : 'see more details'} <span className={styles.glare}></span> <img src={wp} alt="Whatsapp"/></button>
                    </div>
        </div>   
    </motion.section>
    )
}

export default Certificates